import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ModalContext } from '@/utils/contexts/ModalContext';

import styles from '@/views/components/ExplanationPanel/ExplanationPanel.module.scss';

const ExplanationPanel  = ({isVisible}) => {
	const { dict } = useSelector((state) => state.app);

	const { showModal } = useContext(ModalContext);

	const openSimplificationGuide = () => { 
		showModal({
			componentName: 'ModalSimplification',
		}); 
	};

	return (
		<div className={ `${styles['explanation-panel']} ${isVisible ? styles.visible : ''}` }>
			<div className={ styles['content'] }>
				<p>
					{dict.letter.explanationPanel.text.part1}
					<Link 
						className={ styles['link'] } 
						to={ `/dict` }
					>
						&nbsp;{dict.letter.explanationPanel.text.part2}
					</Link>
					{dict.letter.explanationPanel.text.part3}
					<span className={ styles['simplification-label'] }>
						<span className={ styles['label-manual'] }>1 R</span> {dict.letter.explanationPanel.text.part4}
					</span>
					<span className={ styles['simplification-label'] }>
						<span className={ styles['label-automatic'] }>1 A</span> {dict.letter.explanationPanel.text.part5}
					</span>
					<span>{dict.letter.explanationPanel.text.part6}</span>
				</p>
				<p>
					<span 
						className={ styles['info-link'] }
						onClick={ openSimplificationGuide }
					>
						<i className='icon-question'/>{dict.letter.explanationPanel.button}
					</span>
				</p>
			</div>
		</div>
	);
};

export default ExplanationPanel;